/**
 * Utility function to concatenate class names conditionally.
 * Similar to the popular 'classnames' package.
 */
export function cn(...args: Array<string | undefined | false | null>): string {
  return args.filter(Boolean).join(" ");
}

/**
 * Formats a given number of seconds into mm:ss format.
 */
export function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
}